$(document).ready(function(){
    function delete_cookie(name) {
      document.cookie = name +'=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
    }
    
    // logout link
    $(document).on('click','a[href^="/account/logout"]', function(event){
      event.preventDefault();
      var href = $(this).attr("href"),
          target = '';
    
      delete_cookie('cart');
    
      // wait for data to push and then open link
      setTimeout(function() { // now wait 150 milliseconds...
          window.open(href,(!target?"_self":target)); // ...and open the link as usual
      },150);
    
    });
    $(document).on('click','.regimen-accordion-header-right',function(){
        $(this).parents('.regimen-accordion').find('.regimen-accordion-body').toggleClass('active');
    });
  var currentUrl = window.location.href;
  if(window.location.href.indexOf('practice-homepage') > -1 ){
    console.log('called');
    let token = window.location.href.split('/').slice(-1);
      $.ajax({
      dataType: "json",
      url: window.base_url_api + "/practices/"+ token,
      success:function(response){
        if(response?.practice?.logo?.medium?.url){
            $('.secondary-logo').attr('src',response?.practice?.logo?.medium?.url);
            $('.secondary-logo').removeClass('hide');
            $('.secondary-logo').parents('a.header__logo').addClass('multi-logos');
            $('.secondary-logo').parents('section.footer__content').addClass('footer-multi-logos');
        }
        var anchor = $('a[href*="/account/register"]');
        var currentHref = anchor.attr('href');
        if (currentHref.indexOf('?') === -1) {
          anchor.attr('href', currentHref + `?practice=${token}`);
        } else {
          anchor.attr('href', currentHref + `?practice=${token}`);
        }
      }
      });
  }
  $(document).on('change','.loop-custom-options input[type="radio"]',function(){
    if($(this).val() == "onetime"){
        $(this).parents('form').find('.loop-subscription-group-selling-plans-container').hide();
        $(this).parents('form').find('select').val('');
    }else{
        $(this).parents('form').find('.loop-subscription-group-selling-plans-container').show();
        $(this).parents('form').find('select').val($(this).parents('form').find('select option:first').val());
    }
});
});